class Serp {
  constructor (options) {
    this.options = options
  }

  request () {
    return this.options.request
  }

  document () {
    return this.options.document
  }

  page () {
    return {
      url: '',
      download_duration: 0,
      parser_duration: 0,
      ...this.options.page
    }
  }

  items () {
    return this.options.items
  }

  matches () {
    return this.options.matches
  }
}

export default Serp